import { SUPPORTED_LOCALES, type Direction, type Locale } from '@/types/site'

import { getLocalePreference } from '@/services/cookies'

export const DEFAULT_LOCALE: Locale = 'en'

export function isLocale(value?: string): value is Locale {
  return SUPPORTED_LOCALES.includes(value as Locale)
}

export function resolveBrowserLocale() {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LOCALE
  }

  return navigator.language.toLowerCase().startsWith('ar') ? 'ar' : 'en'
}

export function resolvePreferredLocale() {
  return getLocalePreference() ?? resolveBrowserLocale()
}

export function getDirection(locale: Locale): Direction {
  return locale === 'ar' ? 'rtl' : 'ltr'
}

export function getLocalizedPath(locale: Locale, slug = '') {
  const normalizedSlug = slug.replace(/^\/+/, '')
  return normalizedSlug ? `/${locale}/${normalizedSlug}` : `/${locale}`
}

export function swapLocaleInPathname(pathname: string, nextLocale: Locale) {
  const segments = pathname.split('/').filter(Boolean)

  if (segments.length === 0) {
    return getLocalizedPath(nextLocale)
  }

  if (isLocale(segments[0])) {
    segments[0] = nextLocale
    return `/${segments.join('/')}`
  }

  return getLocalizedPath(nextLocale, segments.join('/'))
}
